import * as React from 'react';
import { Panel } from 'react-bootstrap';
import { IDonor, IRecipient } from '../../../models/index';

interface IProps {
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    transplantDate: string,
    isSbs: boolean,
    isGlobal: boolean,
    recipient: IRecipient,
    donor: IDonor
}

const SwapInfo = (props: IProps) => {
    const { chainId, clusterNumber, positionNumber, transplantDate, isSbs, isGlobal, recipient, donor } = props;

    return (
        <Panel>
            <Panel.Heading style={{ fontSize: 16 }}>
                Swap Information ({chainId}/{clusterNumber}/{positionNumber})
            </Panel.Heading>

            <Panel.Body>
                <div className="row not-striped">
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Recipient Center:</div>
                    <div className='col-xs-2'>{recipient.center.alias}</div>
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Recipient:</div>
                    <div className='col-xs-2'>{recipient.alias}</div>
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Recipient Insurance:</div>
                    <div className='col-xs-2'>{recipient.insurance.primaryGroupName}</div>
                </div>
                <div className="row not-striped">
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Donor Center:</div>
                    <div className='col-xs-2'>{donor.center.alias} {donor.rdnCenterId > 0 ? <span style={{color: 'darkred'}}>({donor.rdnCenterAlias})</span> : null}</div>
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Donor:</div>
                    <div className='col-xs-6'>{donor.alias}</div>
                </div>
                <div className="row not-striped">
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>SBS Swap:</div>
                    <div className='col-xs-2'>{isSbs ? "Yes" : "No"}</div>
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Global:</div>
                    <div className='col-xs-6'>{isGlobal ? "Yes" : "No"}</div>
                </div>
                <div className="row not-striped">
                    <div className='col-xs-2' style={{ fontWeight: 500 }}>Transplant Date:</div>
                    <div className='col-xs-10'>{transplantDate}</div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default SwapInfo;